// API 基础地址配置
// 可通过 webpack DefinePlugin 或环境变量覆盖
const API_BASE_URL = process.env.API_BASE_URL || 'https://zswskapi.wensenka.com/api'

export default {
  apiBaseUrl: API_BASE_URL,
  imgServer: 'https://wsk2025.oss-cn-shanghai.aliyuncs.com/wskmallimg/adminimg/',
  limitLength: 10
}



// WEBPACK FOOTER //
// ./src/config/env.js